var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFactory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 10C2.25 9.58579 2.58579 9.25 3 9.25H9.00293C9.41714 9.25 9.75293 9.58579 9.75293 10C9.75293 10.4142 9.41714 10.75 9.00293 10.75H3C2.58579 10.75 2.25 10.4142 2.25 10Z",
    fill: "#76B72A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 4C5.25 2.48122 6.48122 1.25 8 1.25H13.0034C13.4176 1.25 13.7534 1.58579 13.7534 2C13.7534 2.41421 13.4176 2.75 13.0034 2.75H8C7.30964 2.75 6.75 3.30964 6.75 4C6.75 4.41421 6.41421 4.75 6 4.75C5.58579 4.75 5.25 4.41421 5.25 4Z",
    fill: "#76B72A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.25 2C15.25 1.58579 15.5858 1.25 16 1.25H17C17.4142 1.25 17.75 1.58579 17.75 2C17.75 2.41421 17.4142 2.75 17 2.75H16C15.5858 2.75 15.25 2.41421 15.25 2Z",
    fill: "#76B72A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2539 5C10.2539 4.58579 10.5897 4.25 11.0039 4.25H17.0068C17.421 4.25 17.7568 4.58579 17.7568 5C17.7568 5.41421 17.421 5.75 17.0068 5.75H11.0039C10.5897 5.75 10.2539 5.41421 10.2539 5Z",
    fill: "#76B72A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.97349 6.25196C8.9413 6.2501 9.72685 7.03415 9.72685 8.00195V12.4091L14.7739 10.3643C15.0051 10.2706 15.2677 10.2981 15.4746 10.4375C15.6815 10.5768 15.8055 10.81 15.8055 11.0594V12.4187L20.6986 10.3677C20.93 10.2707 21.1945 10.2959 21.4035 10.4347C21.6125 10.5736 21.7382 10.8077 21.7385 11.0586L21.749 20.9979C21.7499 21.9652 20.966 22.75 19.9986 22.7498L4.00088 22.7495C4.00086 22.7495 4.0009 22.7495 4.00088 22.7495C3.03401 22.75 2.25 21.9663 2.25 20.9995V8.00959C2.25 7.0444 3.03146 6.26145 3.99664 6.2596L7.97349 6.25196ZM9.72685 21.2474L19.9988 21.2498C19.9988 21.2498 19.9988 21.2498 19.9988 21.2498C20.137 21.2498 20.2491 21.1378 20.249 20.9995C20.249 20.9995 20.249 20.9996 20.249 20.9995L20.2397 12.1865L15.3454 14.238C15.1139 14.3351 14.8492 14.3098 14.6401 14.1708C14.4311 14.0318 14.3055 13.7974 14.3055 13.5463V12.1725L9.72685 14.0276V21.2474ZM8.22685 21.2476V8.00195C8.22685 7.8637 8.11462 7.75169 7.97637 7.75195L3.99952 7.75959C3.86164 7.75986 3.75 7.87171 3.75 8.00959V20.9995C3.75 21.1377 3.86202 21.2496 4.00006 21.2495L8.22685 21.2476Z",
    fill: "#76B72A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFactory);
export default __webpack_public_path__ + "static/media/ic-factory.4a300e9a042be022db825b649a0444a3.svg";
export { ForwardRef as ReactComponent };